import { render, staticRenderFns } from "./ConfigureMultipleTrialsView.vue?vue&type=template&id=2cd7cc08&scoped=true&"
import script from "./ConfigureMultipleTrialsView.vue?vue&type=script&lang=js&"
export * from "./ConfigureMultipleTrialsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd7cc08",
  null
  
)

export default component.exports